import { createReducer, on } from '@ngrx/store';
import { saveStartHours } from './start-hours.actions';

export const saveStartHoursReducer = (_: any, { value }: { value: any }): any =>
    value;

export const StartHoursReducer = createReducer(
    [],
    on(saveStartHours, saveStartHoursReducer),
);
